import { render, staticRenderFns } from "./enquadramento.vue?vue&type=template&id=4a9420b4&"
import script from "./enquadramento.vue?vue&type=script&lang=js&"
export * from "./enquadramento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports